<app-top-bar [topBarTitle]="topBarTitle"></app-top-bar>
<div class="bpt-main-content-container" *ngIf="isScreenAccessible else screenNotAccessible" style="overflow: auto;">
    <app-quarantined-document-panel-list #docPanel 
    [showLoader] = "showLoader" 
    [quarantinedDocuments]=quarantinedDocuments 
    [isShowCheckbox]=displayShowAllButton 
    [enableInactiveLabel]=displayShowAllLabel 
    (checkboxSelection)="getPanelListData($event)" 
    [showInformationIconCheckbox]=showInformationIconCheckbox 
    [informationIconTooltip]="showAllToolTip" 
    [checkboxLabel]="showAllLabel"
    (reloadQuarantinedDocuments)="getPanelListData($event)">
    </app-quarantined-document-panel-list>
</div>
<ng-template #screenNotAccessible>
    <app-error [errorMessage]="errorMessage"></app-error>
  </ng-template>